import { createSlice } from '@reduxjs/toolkit';
import { IPublicIpaf } from './IPublicIpaf';
import { PublicIpafReducer } from '../../reducers/PublicIpafReducer';

const initialState: IPublicIpaf = {
	formData: [],
	sliceCnpjHasFilled: false,
	preIpafIsUpdated: false,
	hashesStateForms: []
};

export const publicIpafSlice = createSlice({
	name: 'one-page-menu',
	initialState,
	reducers: PublicIpafReducer,
});

export const { setFormProperties, setPreIpafIsUpdated, updateFormHash } =
	publicIpafSlice.actions;

export default publicIpafSlice.reducer;
